/* —— Mobile menu accordion (tam görünüm garantili) —— */
(function(){
  var MQ='(max-width: 991px)';
  function isMobile(){return window.matchMedia(MQ).matches;}

  function openPanel(btn,panel){
    if(!panel) return;
    btn.setAttribute('aria-expanded','true');
    panel.hidden=false;
    panel.classList.remove('is-open');        // önce kısıtlı
    panel.style.maxHeight='0px';
    // ilk ölçüm
    panel.style.maxHeight=panel.scrollHeight+'px';
    // font/yerleşim otursun diye ikinci ölçüm
    requestAnimationFrame(function(){ panel.style.maxHeight=panel.scrollHeight+'px'; });
    setTimeout(function(){ panel.style.maxHeight=panel.scrollHeight+'px'; },120);
    // animasyon bitince sınırsız
    var onEnd=function(e){
      if(e.propertyName!=='max-height') return;
      panel.removeEventListener('transitionend',onEnd);
      panel.classList.add('is-open');
      panel.style.maxHeight='';               // inline kaldır → none devreye girer
    };
    panel.addEventListener('transitionend',onEnd);
  }

  function closePanel(btn,panel){
    if(!panel) return;
    btn.setAttribute('aria-expanded','false');
    // none’dan animasyona dön
    panel.classList.remove('is-open');
    panel.style.maxHeight=panel.scrollHeight+'px';
    requestAnimationFrame(function(){ panel.style.maxHeight='0px'; });
  }

  function handleClick(e){
    if(!isMobile()) return;
    var topBtn=e.target.closest('.kr-mm__link--top[type="button"]');
    var midBtn=e.target.closest('.kr-mm__link--mid[type="button"]');
    var btn=topBtn||midBtn;
    if(!btn) return;

    e.preventDefault(); e.stopPropagation();
    var panel=btn.parentElement.querySelector(':scope > .kr-mm__panel');
    var isOpen=btn.getAttribute('aria-expanded')==='true';
    if(isOpen) closePanel(btn,panel); else openPanel(btn,panel);
  }

  document.addEventListener('click',handleClick,true);

  // Resize’da açık panelleri yeniden kur
  window.addEventListener('resize',function(){
    if(!isMobile()){
      document.querySelectorAll('.kr-mm__panel').forEach(function(p){p.classList.remove('is-open');p.style.maxHeight='';p.hidden=true;});
      document.querySelectorAll('.kr-mm [aria-expanded]').forEach(function(b){b.setAttribute('aria-expanded','false');});
    }else{
      document.querySelectorAll('.kr-mm [aria-expanded="true"]').forEach(function(b){
        var p=b.parentElement && b.parentElement.querySelector(':scope > .kr-mm__panel');
        if(p){ p.classList.add('is-open'); p.style.maxHeight=''; p.hidden=false; }
      });
    }
  });
})();